'use strict';

module.exports = function ($state, $scope) {
    var _this = this;
    _this.data = [];
    _this.tabChar = ";"
    _this.openContent = function ($fileContent) {
        _this.data = [];
        $scope.content = $fileContent;
    };
    _this.processContent = function () {
        _this.data = []
        var maxCol = 0;
        if (_this.tabChar == "TAB")
            _this.tabChar = "\t";
        $scope.content.split("\n").forEach(f => {
            var fila = {}
            if (f.trim() != "") {
                f.split(_this.tabChar).forEach((c, i) => {
                    fila["col".concat((i + 1))] = c;
                    if (i + 1 > maxCol) maxCol = i + 1;
                })
                _this.data.push(fila)
            }
        });
        _this.columnDefs = []
        for (var i = 1; i <= maxCol; i++) {
            _this.columnDefs.push({ headerName: "col" + i, field: "col" + i, width: 150, editable: true });
        }
        _this.gridOptions.api.setColumnDefs(_this.columnDefs);
        _this.gridOptions.api.setRowData(_this.data);
        $state.importTasks["data"] = _this.data;
        $state.importTasks["colnumber"] = maxCol;
    }


    _this.columnDefs = [
    ];
    _this.gridOptions = {
        headerHeight: 40,
        columnDefs: _this.columnDefs,
        enableSorting: true,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        rowData: []
    };
};
